﻿import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { SharedModule } from "../shared/shared.module";
import { ForgotPasswordComponent } from "./forgotPassword/forgotPassword.component";
import { StaffForgotPasswordComponent } from "./forgotPassword/staffforgotPassword.component";
import { LoginComponent } from "./login.component";
import { LoginFormComponent } from "./loginForm/loginForm.component";
import { ExternalLoginComponent } from "./loginForm/extLoginForm.component";
import { ExternalUserEmailVerificationComponent } from "./signup/ExternalUserEmailVerification.component";
import { ExternalUserSignupComponent } from "./signup/ExternalUserSignup.component";
import { SignupComponent } from "./signup/signup.component";
import { DataService } from "../services/dataService";
import { HttpInterceptorService } from '../services/http-interceptor.service';
import { ResetPasswordComponent } from "./resetPassword/resetPassword.component";
import { EmployeeIdValidator } from "./signup/employeeIdSSNValidator";


@NgModule({
    declarations: [ExternalUserEmailVerificationComponent, ExternalUserSignupComponent, ForgotPasswordComponent, LoginComponent, ExternalLoginComponent, LoginFormComponent,  SignupComponent, StaffForgotPasswordComponent, ResetPasswordComponent ],
    exports: [LoginComponent, ResetPasswordComponent],
    imports: [HttpClientModule,BrowserModule, FormsModule, HttpModule, RouterModule,  NguiAutoCompleteModule,SharedModule],
    providers: [DataService,HttpInterceptorService,{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }],
    schemas: [NO_ERRORS_SCHEMA]
})
export class LoginModule {

}
